'use strict';

class ScnSite extends Site {

	static get templateIdentifier() {
		return '#scn-site';
	};

	static get defaultState() {

		return $.extend(super.defaultState, {
			basePath: ['specials.schirn.de'].indexOf(window.location.hostname) != -1
				? (window.location.pathname.indexOf('dev') != -1 ? "/dev/" : "/weneversleep/") :  "/",
		});
	};

	constructor(element, state) {
		super(element, state);
		this.debug = false;

		//template string
		this._view = $('#scnSite_ScnSite').html();
		this._responsiveIframe = responsiveIframe();
		this._responsiveIframe.allowResponsiveEmbedding();

		_.bindAll(this, 'loadData', 'reloadPage');

		return this
	}

	updateViewport(scrollToTop = false) {
		this._responsiveIframe.messageParent();
		//window.parent.postMessage({name: 'resizeIframe', params: {height: document.body.offsetHeight}}, '*');
		if(scrollToTop) window.parent.postMessage({name: 'scrollToTop'}, '*');
	}

	init() {
		this.$page = $('#site-page', this.$el);
		this.nav = new Navigation($('#nav-header', this.$el)).render().init();
		this.$spinner = $('#spinner', this.$el);

		if(Utils.isInIframe()) $('body').addClass('no-scroll');

		return this;
	}

	showSpinner() {
		this.$spinner.removeClass('hidden').spin('large', '#fff');
		//TweenLite.from(this.$spinner, 1000, {opacity: 0, ease: Power2.easeOut});
	}

	hideSpinner() {
		this.$spinner.addClass('hidden').spin(false);
	}

	loadData(callbackFn) {
		let params = Utils.retrieveGetParams();
		let lang = params.lang && params.lang == "en" ? 'en' : 'de';
		//lang = 'en';
		$.ajax({
			dataType: 'json',
			cache: false,
			url: 'content/'+ lang +'.json'
		}).done(function(data) {
			Translator.getInstance().addLanguageTable(lang, data, true);
			callbackFn();
		}).fail(function(evt, f, g) {
			console.error('loadData', evt, f, g);
		});
	}

	_route(path, params) {
		let pageClassName = '';
		let showNav = true;

		switch(path){
			case 'page01':
			{
				pageClassName = 'Page01';
				break;
			}
			case 'page02':
			{
				pageClassName = 'Page02';
				break;
			}
			case 'page03':
			{
				pageClassName = 'Page03';
				break;
			}
			case 'page04':
			{
				pageClassName = 'Page04';
				break;
			}
			case 'page05':
			{
				pageClassName = 'Page05';
				break;
			}
			case 'thankyou':
			{
				pageClassName = 'ThankYou';
				break;
			}
			case 'home':
			default:
			{
				pageClassName = 'Home';
				showNav = false;
				break;
			}
		}

		this.state.currentPage = new site.components[pageClassName]().render().init();

		this.nav.state.pageNumber = this.state.currentPage.state.pageNumber;
		this.nav.state.show = showNav;
		this.nav.update();

		return this.update();
	}

	update(force = false) {
		if(!_.isEqual(this._internalState, this.state) || force) {
			//update page
			if(this._internalState.currentPage && this._internalState.currentPage.$el) this._internalState.currentPage.$el.detach();
			this.$page.append(this.state.currentPage.$el);
			this.state.currentPage.update();

			scroll(0,0);

			this._internalState = _.clone(this.state);
			this.$el.trigger(ComponentEvent.UPDATE_STATE);
		}

		this.updateViewport(true);
		return this;
	}

	reloadPage(){
		if(this.state.currentPage) {
			let pageClassName = this.state.currentPage.constructor.name;
			this.state.currentPage.destroy();
			this.state.currentPage = new site.components[pageClassName]().render().init();
			this.update(true);
		}
	}
}
